<template>
  <div>
    <el-drawer
      show-close
      visible
      :size="800"
      :title="$l('drawer_title_control_product_info') || '控价产品详情'"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="openDialog"
      append-to-body
    >
      <div class="drawer-main">
        <div class="title mb-2">
          {{ $l('title_price_product_info') || '控价产品信息' }}
        </div>
        <el-descriptions
          class="margin-top mb-4"
          :column="6"
          size="small"
          border
        >
          <el-descriptions-item
            :label="$l('form_label_goodsName') || '产品描述'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="3"
          >
            {{ detailDataForm.goodsName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_categoryCode') || '产品分类'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="3"
          >
            {{ detailDataForm.categoryFullName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_goodsSize') || '单品尺寸'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="2"
          >
            {{ detailDataForm.goodsSize || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_unitCbm') || '单品体积'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="2"
          >
            {{ detailDataForm.unitCbm || '' }} m³
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_unitWeight') || '单品重量'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="2"
          >
            {{ detailDataForm.unitWeight || '' }} g
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_ctnSize') || '外箱尺寸'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="2"
          >
            {{ detailDataForm.ctnSize || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_inCtnQty') || '入数'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="2"
          >
            {{ detailDataForm.inCtnQty || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('form_label_ftyPrice') || '工厂价'"
            :labelStyle="{ width: '100px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
            :span="2"
          >
            {{ detailDataForm.ftyPrice || '' }}
            {{ detailDataForm.v_ftyCurrencyUnit || '' }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="title mb-2">
          {{ $l('title_product_market') || '产品销售市场' }}
        </div>
        <el-form
          ref="form"
          size="mini"
          :model="formData"
          :rules="rules"
          :disabled="disabledForm"
        >
          <el-row :gutter="10">
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_marketId') || '上架市场'"
                prop="marketId"
              >
                <dict-select
                  v-model="formData.marketId"
                  :selectedLabel.sync="formData.marketName"
                  url="/ecom/amz/market/dictSelect"
                  :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                  filterable
                  size="mini"
                  style="width:100%"
                  @change="onChangeParamInfo"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_regionName') || '所在国家'"
                prop="regionCode"
              >
                <dict-select
                  v-model="formData.regionCode"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'region' }"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  :selectedLabel.sync="formData.regionName"
                  size="mini"
                  clearable
                  filterable
                  @change="onChangeParamInfo"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_currency') || '货币单位'"
                prop="currency"
              >
                <el-input
                  v-model="formData.v_currency"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                :label="$l('form_label_usdExchangeRate') || '美元汇率'"
                prop="usdExchangeRate"
              >
                <el-input
                  v-model="formData.usdExchangeRate"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  readonly
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-descriptions
            class="margin-top mb-4"
            :column="3"
            size="small"
            border
          >
            <el-descriptions-item
              :label="$l('descriptions_label_exchangeRate') || '所在国汇率'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.exchangeRate || '0' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_commissionRate') || '佣金比例'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.commissionRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_advertisingRate') || '广告比例'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.advertisingRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_storageUnitPrice') || '仓储单价'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ format(paramDetailForm.storageUnitPrice) || '0' }}
              {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_inStorageMonth') || '在库时长(月)'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.inStorageMonth || '0' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_salesReturnRate') || '退货率'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.salesReturnRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_shipUnitPrice') || '头程拼柜单价'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ format(paramDetailForm.shipUnitPrice) || '0' }} CNY
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_truckingFee') || '货代卡车费'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ format(paramDetailForm.truckingFee) || '0' }} CNY
            </el-descriptions-item>

            <el-descriptions-item
              :label="$l('descriptions_label_freightFee') || '货代头程运费'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ format(paramDetailForm.freightFee) || '0' }} CNY
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_tariffsRate') || '关税'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.tariffsRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_salesTax') || '消费税'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.salesTax || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_localTax') || '地方税'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.localTax || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_vatRate') || 'VAT'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.vatRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_refundTaxRate') || '退税率'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.refundTaxRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_chinaVatRate') || '增值税率'"
              :labelStyle="{ width: '142px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ paramDetailForm.chinaVatRate || '0' }} %
            </el-descriptions-item>
          </el-descriptions>
          <div class="title mb-2">
            {{ $l('title_label_product_profit_cal') || '产品利润测算' }}
          </div>
          <el-descriptions
            class="margin-top mb-4"
            :column="3"
            size="small"
            border
          >
            <el-descriptions-item
              :label="$l('descriptions_label_salesPrice') || '售价'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              <div class="d-flex" style="align-items: center;">
                <InputFormat
                  size="mini"
                  v-model="formData.salesPrice"
                  :precision="2"
                  @input="cal"
                />
                <div class="ml-2" style="font-size: 14px;">
                  {{ paramDetailForm.currency }}
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_clearanceUnitPrice') || '清关单价'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              <div
                class="d-flex"
                style="align-items: center;justify-content: space-between;"
              >
                <div>
                  {{ formData.clearanceUnitPrice || '0' }}
                  {{ !disableLocalCurrency ? formData.currency : 'USD' }}
                </div>

                <el-button
                  size="mini"
                  icon="el-icon-more"
                  plain
                  class="add-p-b bg-ef"
                  @click="onOpenClearanceOption"
                >
                </el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_deliveryCost') || '配送费'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              <div class="d-flex" style="align-items: center;">
                <InputFormat
                  size="mini"
                  v-model="formData.deliveryCost"
                  :precision="2"
                  @input="cal"
                />
                <div class="ml-2" style="font-size: 14px;">
                  {{ paramDetailForm.currency }}
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_profit') || '毛利'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.profit || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_profitRate') || '毛利率'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.profitRate || '0' }} %
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_commissionCost') || '佣金花费'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.commissionCost || '0' }}
              {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_advertisingCost') || '广告花费'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.advertisingCost || '0' }}
              {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_storageCost') || '仓储花费'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.storageCost || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_restockingCost') || '退货花费'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.restockingCost || '0' }}
              {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_shipCost') || '头程花费'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.shipCost || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_tariffs') || '关税'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.tariffs || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_salesTax') || '消费税'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.salesTax || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_localTax') || '地方税'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.localTax || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_vat') || 'VAT'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.vat || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('descriptions_label_refundTax') || '退税'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ formData.refundTax || '0' }} {{ paramDetailForm.currency }}
            </el-descriptions-item>
            <!-- <el-descriptions-item
              :label="'配送重量'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              <InputFormat
                size="mini"
                v-model="formData.deliveryWeight"
                :precision="2"
              />
            </el-descriptions-item>
            <el-descriptions-item
              :label="'配送标准'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              {{ '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="'配送包装'"
              :labelStyle="{ width: '130px', height: '32px' }"
              :contentStyle="{ width: '235px', height: '32px' }"
            >
              <el-input
                v-model="formData.deliveryPackage"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="mini"
                style="width: 100%"
              ></el-input>
            </el-descriptions-item> -->
          </el-descriptions>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button
          type="primary"
          size="small"
          v-if="!disabledForm"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      :title="$l('dialog_title_clearance_set') || '清关单价参数设置'"
      :visible.sync="clearanceOption"
      width="800px"
      show-close
      :before-close="onCloseClearanceOption"
    >
      <div>
        <div class="title-2 mb-2">{{ formData.marketName }}</div>
        <el-descriptions
          class="margin-top mb-4"
          :column="3"
          size="small"
          border
        >
          <el-descriptions-item
            :label="$l('descriptions_label_regionName') || '所在国'"
            :labelStyle="{ width: '130px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ formData.regionName || '' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('descriptions_label_currency') || '货币单位'"
            :labelStyle="{ width: '130px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ formData.v_currency }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('descriptions_label_exchange_rate') || '汇率'"
            :labelStyle="{ width: '130px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ formData.exchangeRate || '0' }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('descriptions_label_ftyPrice') || '工厂价'"
            :labelStyle="{ width: '130px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ formData.ftyPrice || '0' }}
            {{ detailDataForm.v_ftyCurrencyUnit }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('descriptions_label_sales_price') || '市场售价'"
            :labelStyle="{ width: '130px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ formData.salesPrice || '0' }}
            {{ paramDetailForm.currency }}
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('descriptions_label_usdExchangeRate') || '美元汇率'"
            :labelStyle="{ width: '130px', height: '32px' }"
            :contentStyle="{ width: '235px', height: '32px' }"
          >
            {{ formData.usdExchangeRate || '0' }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="title-2 mt-4 mb-2">
          {{ $l('title_clearance_currency_type') || '清关单价货币单位' }}
        </div>
        <el-radio-group v-model="clearanceFormData.currencyType">
          <el-radio :label="'A'" :disabled="disableCurrencyToUSD">{{
            $l('radio_local_to_usd') || '所在国货币转美元'
          }}</el-radio>
          <el-radio :label="'B'" :disabled="disableLocalCurrency">{{
            $l('radio_local_currency') || '所在国货币'
          }}</el-radio>
        </el-radio-group>
        <div class="d-flex">
          <div>
            <div class="title-2 mt-4 mb-2">
              {{ $l('title_clearance_formula') || '清关单价计算公式' }}
            </div>
            <div>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-select
                    size="mini"
                    disabled
                    v-model="clearanceFormData.priceType"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                  >
                    <el-option
                      v-for="item in priceTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-input
                    v-model="clearanceFormData.formula"
                    :placeholder="
                      $l('tips_pls_input_formula') || '请输入系数计算公式'
                    "
                    maxlength="100"
                    clearable
                    size="mini"
                    style="width: 100%"
                  ></el-input>
                </el-col>
                <el-col :span="4">
                  <el-button
                    size="mini"
                    @click="calClearanceFormulas()"
                    type="success"
                  >
                    {{ $l('btn_cal') || '计算' }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
          <div>
            <div class="title-2 mt-4 mb-2">
              {{ $l('title_clearance_unit_price') || '清关单价' }}
            </div>
            <div>
              <el-row :gutter="10" style="display: flex;align-items: center;">
                <el-col :span="12">
                  <el-input
                    v-model="clearanceFormData.clearanceUnitPrice"
                    readonly
                    clearable
                    size="mini"
                    style="width: 100%"
                  ></el-input>
                </el-col>
                <el-col :span="12" style="font-size: 14px;font-weight: 600;">
                  {{ !disableLocalCurrency ? formData.currency : 'USD' }}
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseClearanceOption" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="saveClearanceFormulas" type="primary" size="small">
          {{ $l('btn_confirm_use') || '确认使用' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import InputFormat from '../input-format'
import validate from '@/libs/util.validate'
import { format, divideRound } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
import calcInterestRate from '../mixins/calc-interest-rate'
export default {
  components: { InputFormat },
  mixins: [EditLoading, calcInterestRate],
  props: {
    type: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    amzPriceControlCode: { type: String, default: '' },
    amzPriceControlDetailCode: { type: String, default: '' },
    amzDetailMarketCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        v_currency: '',
      },
      clearanceFormData: {
        priceType: '',
        formula: '',
        clearanceUnitPrice: '',
        currencyType: '',
      },
      calcForm: {},
      format: (number) => format(number),
      detailDataForm: {},
      paramDetailForm: {},
      rules: {
        marketId: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currency: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        salesPrice: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        deliveryPackage: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      priceTypeOptions: [
        {
          label: this.$l('select_label_fty_price') || '工厂价',
          value: 'ftyPrice',
        },
        {
          label: this.$l('select_label_sales_price') || '售价',
          value: 'salesPrice',
        },
      ],
      backDialogVisible: false,
      clearanceOption: false,
    }
  },
  async mounted() {
    await this.getDetailData()
    await this.getData()
  },
  computed: {
    isView() {
      return this.type == 'detail'
    },
    disabledForm() {
      return this.disabled || this.isView
    },
    disableCurrencyToUSD() {
      return ['amazonUs', 'amazonJapan'].includes(this.formData.marketId)
    },
    disableLocalCurrency() {
      return !['amazonUs', 'amazonJapan'].includes(this.formData.marketId)
    },
  },
  methods: {
    saveClearanceFormulas() {
      this.formData.clearanceUnitPriceFormulas = JSON.stringify(
        this.clearanceFormData
      )
      this.formData.clearanceUnitPrice = this.clearanceFormData.clearanceUnitPrice
      this.onCloseClearanceOption()
    },
    calClearanceFormulas() {
      const val = this.formData[this.clearanceFormData.priceType] || 0
      let calculate = val
      if (this.clearanceFormData.currencyType == 'A') {
        calculate =
          calculate +
          '*' +
          this.formData.exchangeRate +
          '/' +
          this.formData.usdExchangeRate
      }
      calculate = calculate + this.clearanceFormData.formula
      this.$api
        .masterFormulaCalculateApi({
          calculate,
        })
        .then((res) => {
          this.clearanceFormData.clearanceUnitPrice = divideRound(
            res.body || 0,
            1,
            2
          )
        })
    },
    onCloseClearanceOption() {
      this.clearanceOption = false
      this.cal()
    },
    onOpenClearanceOption() {
      if (
        !this.formData.marketId ||
        !this.formData.regionCode ||
        !this.detailDataForm.categoryCode
      ) {
        this.$message.warning('请先选择市场和所在国家')
        return
      }
      if (!this.formData.salesPrice) {
        this.$message.warning('请先填写售价!')
        return
      }
      if (this.disableCurrencyToUSD) {
        this.clearanceFormData.currencyType = 'B'
      }
      if (this.disableLocalCurrency) {
        this.clearanceFormData.currencyType = 'A'
      }
      if (['amazonUs'].includes(this.formData.marketId)) {
        this.clearanceFormData.priceType = 'ftyPrice'
      } else {
        this.clearanceFormData.priceType = 'salesPrice'
      }
      const clearanceUnitPriceFormulas =
        this.formData.clearanceUnitPriceFormulas || '{}'
      const clearanceParam = JSON.parse(clearanceUnitPriceFormulas)
      this.clearanceFormData.clearanceUnitPrice =
        clearanceParam.clearanceUnitPrice || 0
      this.clearanceFormData.formula = clearanceParam.formula || ''
      this.clearanceOption = true
    },
    async onChangeParamInfo() {
      this.paramDetailForm = {}
      const t_form = {
        marketId: this.formData.marketId,
        regionCode: this.formData.regionCode,
        categoryCode: this.detailDataForm.categoryCode,
      }
      if (
        !this.formData.marketId ||
        !this.formData.regionCode ||
        !this.detailDataForm.categoryCode
      ) {
        this.formData = {
          ...t_form,
        }
        return
      }
      this.formData = {
        ...t_form,
      }
      await this.getDetailPrice()

      this.cal()
    },
    async getDetailPrice() {
      const res = await this.$api
        .ecomAmzPriceControlParamsDetailPriceApi({
          marketId: this.formData.marketId,
          regionCode: this.formData.regionCode,
          categoryCode: this.detailDataForm.categoryCode,
        })
        .catch(() => null)
      if (!res) {
        return
      }
      const resData = res.body
      if (!resData) {
        this.$alert(
          this.$l('tips_control_param_not_find') ||
            '控价参数未找到,请重新选择！',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          }
        )
        this.formData.regionCode = ''
        return
      }
      this.paramDetailForm = res.body || {}
      this.formData = {
        ...this.formData,
        ...this.paramDetailForm,
        ftyPrice: this.detailDataForm.ftyPrice,
      }
      this.calcForm = {
        ...this.paramDetailForm,
        ...this.formData,
        regionCode: this.formData.regionCode,
        ftyPrice: this.detailDataForm.ftyPrice,
        unitCbm: this.detailDataForm.unitCbm,
      }
      this.cal()
    },
    cal() {
      if (
        !this.formData.salesPrice ||
        !this.calcForm.regionCode ||
        !this.calcForm.marketId
      )
        return
      this.calcForm = {
        ...this.calcForm,
        ...this.formData,
      }
      const calData = this.calculate(this.calcForm) || {}
      this.formData = {
        ...this.formData,
        ...calData,
      }
    },
    openDialog() {
      if (!this.disabledForm) {
        this.backDialogVisible = true
        return
      }
      this.close()
    },
    async getData() {
      if (!this.amzDetailMarketCode) return
      const res = await this.$api
        .ecomAmzPriceControlDetailMarketDetailApi({
          amzDetailMarketCode: this.amzDetailMarketCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body || {}
      await this.getDetailPrice()
    },
    async getDetailData() {
      if (!this.amzPriceControlDetailCode) return
      const res = await this.$api
        .ecomAmzPriceControlDetailDetailApi({
          amzPriceControlDetailCode: this.amzPriceControlDetailCode,
        })
        .catch(() => null)
      if (!res) return
      this.detailDataForm = res.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        this.backDialogVisible = false
        return
      }
      const { amzControlParamsCode } = this.paramDetailForm
      if (!amzControlParamsCode) {
        this.backDialogVisible = false
        this.$alert(
          this.$l('tips_control_param_not_find') || '控价参数不存在请重新选择',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          }
        )
        return
      }
      const { salesPrice, deliveryCost, clearanceUnitPrice } = this.formData
      if (!salesPrice && salesPrice != 0) {
        this.backDialogVisible = false
        this.$alert(
          this.$l('tips_pls_input_sales_price') || '请添写售价',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          }
        )
        return
      }

      if (!deliveryCost && deliveryCost != 0) {
        this.backDialogVisible = false
        this.$alert(
          this.$l('tips_pls_input_delivery_cost') || '请添写配送费',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          }
        )
        return
      }

      if (!clearanceUnitPrice && clearanceUnitPrice != 0) {
        this.backDialogVisible = false
        this.$alert(
          this.$l('tips_pls_input_clearanceUnitPrice') || '请添写清关单价',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          }
        )
        return
      }

      if (!salesPrice || !deliveryCost || !clearanceUnitPrice) {
        this.backDialogVisible = false
        this.$confirm(
          this.$l('tips_check_price_then_0') ||
            '售价、清关单价或配送费为零是否保存？',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(async () => {
            await this.saveData()
          })
          .catch(() => {})
        return
      }
      await this.saveData()
    },
    async saveData() {
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzPriceControlDetailMarketSaveApi({
          ...this.formData,
          amzPriceControlCode: this.amzPriceControlCode,
          amzPriceControlDetailCode: this.amzPriceControlDetailCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.backDialogVisible = false
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.backDialogVisible = false

      this.close()
      this.$emit('reload')
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 20px 30px;
  display: flex;
  justify-content: flex-end;
}
.title {
  height: 23px;
  line-height: 23px;
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}
.title-2 {
  height: 23px;
  line-height: 23px;
  color: #101010;
  font-size: 14px;
  font-weight: 600;
}
::v-deep {
  .el-drawer__header {
    font-size: 14px !important;
  }
}
.add-p-b {
  border-radius: 4px !important;
}
.bg-ef {
  background-color: #efefef !important;
  border: none !important;
}
</style>
